import { makeStyles } from '@material-ui/core';

const useRadioGroupStyles = makeStyles({
    radioGroupRow: {
        width: '30%',
        height: 'auto',
        display: 'flex',
        flexWrap: 'nowrap',
        flexDirection: 'row',
        whiteSpace: 'nowrap',
    },
    radioGroupColumn: {
        width: 'auto',
        height: 'auto',
        display: 'flex',
        flexWrap: 'wrap',
        flexDirection: 'column',
    }
});

export default useRadioGroupStyles;